.fp-presentation-card
  .fp-presentation-card--image
    FairplayerImageVue(:url='item.imageUrl')
  .fp-presentation-card--title(:title='item.title') {{ item.title }}
  .fp-presentation-card--line(v-if='item.pricing' data-test='pricing')
    ExclusivePriceVue(:pricing='item.pricing')
  .fp-presentation-card--mask(v-if='item.maskText')
    .fp-badge(data-test='mask-text') {{ item.maskText }}
